import {
  GET_LEGALMASTER,
  GET_LEGALMASTER_SUCCESS,
  GET_LEGALMASTER_FAIL,
  DELETE_LEGALMASTER,
  DELETE_LEGALMASTER_SUCCESS,
  DELETE_LEGALMASTER_FAIL,
  UPDATE_LEGALMASTER,
  UPDATE_LEGALMASTER_SUCCESS,
  UPDATE_LEGALMASTER_FAIL,
  ADD_NEW_LEGALMASTER,
  ADD_LEGALMASTER_SUCCESS,
  ADD_LEGALMASTER_FAIL,
  LEGALMASTER_LOADING,
  LEGALMASTER_RESET,
} from "./actionType";

export const resetLegalMasterState = (actionType) => ({
  type: LEGALMASTER_RESET,
  payload: { actionType },
});

export const getLegalMasterSuccess = (actionType, data) => ({
  type: GET_LEGALMASTER_SUCCESS,
  payload: { actionType, data },
});

export const getLegalMasterFail = (actionType, error) => ({
  type: GET_LEGALMASTER_FAIL,
  payload: { actionType, error },
});

export const getLegalMaster = data => ({
  type: GET_LEGALMASTER,
  payload: data,
});

export const getLegalMasterLoading = () => ({
  type: LEGALMASTER_LOADING
});

export const deleteLegalMaster = data => ({
  type: DELETE_LEGALMASTER,
  payload: data,
});

export const deleteLegalMasterSuccess = data => ({
  type: DELETE_LEGALMASTER_SUCCESS,
  payload: data,
});

export const deleteLegalMasterFail = error => ({
  type: DELETE_LEGALMASTER_FAIL,
  payload: error,
});

export const updateLegalMaster = data => ({
  type: UPDATE_LEGALMASTER,
  payload: data,
});

export const updateLegalMasterFail = error => ({
  type: UPDATE_LEGALMASTER_FAIL,
  payload: error,
});

export const updateLegalMasterSuccess = data => ({
  type: UPDATE_LEGALMASTER_SUCCESS,
  payload: data,
});

export const addNewLegalMaster = data => ({
  type: ADD_NEW_LEGALMASTER,
  payload: data,
});

export const addLegalMasterSuccess = data => ({
  type: ADD_LEGALMASTER_SUCCESS,
  payload: data,
});

export const addLegalMasterFail = error => ({
  type: ADD_LEGALMASTER_FAIL,
  payload: error,
});